export const OPEN_MODAL = 'OPEN_MODAL';

export const FIELD_LITHOLOGY_LIST = 'FIELD_LITHOLOGY_LIST';
export const FIELD_LITHOLOGY_LIST_SUCCESS = 'FIELD_LITHOLOGY_LIST_SUCCESS';
export const FIELD_LITHOLOGY_LIST_ERROR = 'FIELD_LITHOLOGY_LIST_ERROR';
export const FIELD_LITHOLOGY_UPDATE_DATA = 'FIELD_LITHOLOGY_UPDATE_DATA';